import axios from "axios";

export const fetchLogin = (email, password) =>
    axios.post(`${process.env.REACT_APP_API_URL}/user/login`, {
        email,
        password
    });

export const getUser = () =>
    axios.get(`${process.env.REACT_APP_API_URL}/user/user`);

export const getAllUsers = () =>
    axios.get(`${process.env.REACT_APP_API_URL}/user/allusers`);

export const fetchLogout = () =>
    axios.get(`${process.env.REACT_APP_API_URL}/user/logout`);